<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { TabsListProps } from 'reka-ui';
  import { TabsList } from 'reka-ui';
  import { inject } from 'vue';
  import type { HTMLAttributes } from 'vue';

  import TabsIndicator from '@ui/components/tabs/TabsIndicator.vue';
  import { cn } from '@ui/utils/utils';

  const props = defineProps<TabsListProps & { class?: HTMLAttributes['class'] }>();

  const delegatedProps = reactiveOmit(props, 'class');

  const context = inject<{ variant: 'glass' | 'underline' | 'panel' }>('tabs');

  const panelClasses = 'flex w-full h-12 divide-x divide-border text-foreground';
  const glassClasses =
    'relative inline-flex h-9 w-fit items-center justify-center p-[3px] bg-muted text-muted-foreground rounded-sm';
  const underlineClasses =
    'relative inline-flex h-9 w-fit items-center justify-center p-[3px] text-foreground gap-x-2';
</script>

<template>
  <TabsList
    data-slot="tabs-list"
    v-bind="delegatedProps"
    :class="
      cn(
        context.variant === 'panel'
          ? panelClasses
          : context.variant === 'glass'
            ? glassClasses
            : underlineClasses,
        props.class,
      )
    "
  >
    <TabsIndicator v-if="context.variant !== 'panel'" :variant="context.variant" />
    <slot />
  </TabsList>
</template>
